import { combineReducers } from 'redux'
import product from './productReducer'
import step from './stepReducer'
import components from './componentsReducer'
import widgets from './widgetsReducer'
import routing from './routingReducer'
import chatbot from './chatbotReducer'

export default combineReducers({
  product,
  step,
  components,
  widgets,
  routing,
  chatbot
})



// WEBPACK FOOTER //
// ./state/reducers/rootReducer.js